import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Renders a Chart.js chart from a server-built config. Generic and
// domain-agnostic: the server hands over the complete Chart.js config (type,
// data, options) via the `config` value; this controller only applies
// theme-aware axis/legend colors and manages the chart's lifecycle across
// Turbo page caching. The theme toggle is a full page reload, so reading the
// `dark` class once at connect is enough — no live recolor needed.
export default class extends Controller {
  static values = { config: Object }
  static targets = ["canvas"]

  connect() {
    const dark = document.documentElement.classList.contains("dark")
    Chart.defaults.color = dark ? "#a1a1aa" : "#52525b"
    Chart.defaults.borderColor = dark ? "#27272a" : "#e4e4e7"

    this.chart = new Chart(this.canvasTarget, this.configValue)
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
